import type { VoidFunctionComponent } from 'react';
import { Icon, icons } from '../../../../../generic';
import { BUTTON_SIZE, BUTTON_TYPE, NavigationButton } from '../../../../../generic/Button';
import styles from '../SidePanel.module.less';
import { getReportURL, ReportActions } from '../../utils';
import type { ReportButtonBaseProps } from './types';
import Flex from '../../../../../generic/Flex';

/**
 * Provides a download report button for the distribution panel
 */
const DownloadButton: VoidFunctionComponent<ReportButtonBaseProps> = ({ reportContext, reportOptions }) => {
  const reportDownloadUrl = getReportURL(ReportActions.Download, reportContext, reportOptions);

  return (
    <div className={styles.actionButton}>
      <NavigationButton
        to={reportDownloadUrl}
        type={BUTTON_TYPE.PRIMARY}
        size={BUTTON_SIZE.MEDIUM}
        isFullWidth
        openInNewTab
      >
        <Flex gap="8px">
          <Icon icon={icons.fileOutline} />
          <span>Download Report</span>
        </Flex>
      </NavigationButton>
    </div>
  );
};

export default DownloadButton;
